import React, { useState, useEffect } from 'react';
import './styles/output.css';
import Countdown from 'react-countdown';
import logo from './assets/logo.png'

export default function App() {

  

	// const questions = [
	// 	{
	// 		questionText: 'What is the capital of France?',
	// 		answerOptions: [
	// 			{ answerText: 'New York', isCorrect: false },
	// 			{ answerText: 'London', isCorrect: false },
	// 			{ answerText: 'Paris', isCorrect: true },
	// 			{ answerText: 'Dublin', isCorrect: false },
	// 		],
	// 	},
	// 	{
	// 		questionText: 'Who is CEO of Tesla?',
	// 		answerOptions: [
	// 			{ answerText: 'Jeff Bezos', isCorrect: false },
	// 			{ answerText: 'Elon Musk', isCorrect: true },
	// 			{ answerText: 'Bill Gates', isCorrect: false },
	// 			{ answerText: 'Tony Stark', isCorrect: false },
	// 		],
	// 	},
	// 	{
	// 		questionText: 'The iPhone was created by which company?',
	// 		answerOptions: [
	// 			{ answerText: 'Apple', isCorrect: true },
	// 			{ answerText: 'Intel', isCorrect: false },
	// 			{ answerText: 'Amazon', isCorrect: false },
	// 			{ answerText: 'Microsoft', isCorrect: false },
	// 		],
	// 	},
	// 	{
	// 		questionText: 'How many Harry Potter books are there?',
	// 		answerOptions: [
	// 			{ answerText: '1', isCorrect: false },
	// 			{ answerText: '4', isCorrect: false },
	// 			{ answerText: '6', isCorrect: false },
	// 			{ answerText: '7', isCorrect: true },
	// 		],
	// 	},
	// ];

  const [questions, setQuestions] = useState([]);
  const [user, setUser] = useState("");
  const [userText, setUserText] = useState("");
  const [countdown, setCountdown] = useState((0 * 60 + 20) * 1000)
  const [btnDisabled, setBtnDisabled] = useState(true);

  const handleUserTextChange = (value) => {
    if (/^\d\d\d\d\/\d\d\d\d$/i.test(value)){
      setBtnDisabled(false)
    } else {
      setBtnDisabled(true)
    }
    setUserText(value)
  }

  const fetchQuestions = () => {
    console.log(user)
    console.log(typeof user)
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user: user })
    }
    return fetch("https://ancient-falls-92767.herokuapp.com/questions", requestOptions)
          .then((response) => response.json())
          .then((data) => setQuestions(data))
  }

  useEffect(() => {
    console.log(user)
    fetchQuestions()
  }, [user])

  

  const fetchScore = (answers) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user: user, given_answers: answers })
    }
    return fetch("https://ancient-falls-92767.herokuapp.com/answers", requestOptions)
          .then((response) => response.json())
          .then((data) => {
            setScore(data.score)
            setShowScore(true);
            console.log("GOT DATA")
            console.log(data)
          })
  }

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);

  const [givenAnswers, setGivenAnswers] = useState([]);

  const handleAnswerButtonClick = (_id, index) => {
    const given = {
      _id: _id,
      correctID: index
    }
    var tmp = Array.from(givenAnswers)
    console.log(tmp)
    tmp.push(given)
    setGivenAnswers(tmp)
    console.log(givenAnswers)

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      fetchScore(givenAnswers);
      
    }
  }

  const handleStart = () => {
    const encoded = Buffer.from(userText, 'utf-8').toString('base64')
    setUser(encoded)
  }

  const gotoHome = () => {
    setShowScore(false)
    setCurrentQuestion(0)
    setGivenAnswers([])
    setUser("")
  }
  

  const [showScore, setShowScore] = useState(false);

  const Footer = () => {
    return <footer class="footer bg-gray-800 w-screen relative">
            <div class="container mx-auto px-6">
                <div class="mt-2 flex flex-col items-center">
                    <div class="sm:w-2/3 text-center py-6">
                        <p class="text-sm text-gray-400 font-bold mb-2">
                            Project by The Royal College General Knowledge Club and The Royal College Computer Society
                        </p>
                    </div>
                </div>
            </div>
        </footer>
  }

  const Renderer = ({hours, minutes, seconds, completed}) => {
    if(completed) {
      console.log("DONE")
      // setUser("");
      fetchScore(givenAnswers);
      // handleAnswerButtonClick(0,0)
        
    }
    const minStr = minutes < 10 ? `0${minutes}` : minutes
    const secStr = seconds < 10 ? `0${seconds}` : seconds
    return <span className="text-3xl m-10">Timer: <code className=" bg-gray-800 p-1 rounded">{secStr}s</code></span>
    
    
  };
  
  if(user !== ""){
    if(questions.length > 0 ){
      console.log(questions)
      return (
        <div className='app bg-gray-900 lg:pt-20 md:pt-20 sm:pt-0 min-h-screen flex justify-center items-start flex-col text-white items-center'>
          {/* HINT: replace "false" with logic to display the 
          score when the user has answered all the questions */}
          <content className="mb-auto lg:pr-20 lg:pl-20 md:pr-20 md:pl-20 sm:pr-20 lg:pl-20 pb-20 flex justify-center items-start flex-col text-white items-center w-screen">
            {showScore ? (
              <div className="items-center justify-center flex flex-col mt-30"><div className='score-section text-2xl'>You scored {score} out of {questions.length} 🎉</div> <input className='p-4 rounded-lg font-bold text-white mt-5 bg-green-600 hover:bg-gray-600 disabled:bg-gray-600 ' type="button" value="Go to Home" onClick={gotoHome}/></div>
            ) : (
              <>
                <Countdown date={Date.now() + countdown} renderer={Renderer} />
                <div className="bg-gray-700 lg:w-1/3 lg:h-2/3 md:h-2/3 sm:h-full md:w-2/3 sm:w-full  shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col">
                  <div className='question-section'>
                    <div className='question-count pb-3'>
                      <span>Question {currentQuestion + 1}</span>/{questions.length}
                    </div>
                    
                    <div className='question-text  text-2xl'>{questions[currentQuestion].question}</div>
                  </div>
                  <div className='flex-grow'></div>
                  <div className='answer-section text-gray-400 mt-5 text-lg'>
                    {questions[currentQuestion].answers.map((answerOption, index) => (
                      <button className='p-4 bg-green-600 rounded-lg font-bold text-white mt-5 hover:bg-gray-600 mr-8' onClick={() => handleAnswerButtonClick(questions[currentQuestion]._id, index)}>{answerOption}</button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </content>
          <Footer />
        </div>
      );
    } else {
      return (
        <div className='app bg-gray-900 pt-20 h-screen flex justify-center items-start flex-col text-white items-center'>
          <content className="mb-auto bg-gray-900 pr-20 pl-20 pb-20 h-screen flex items-start flex-col text-white items-center">
            <h1 className='text-2xl'>Loading</h1>
          </content>
          <Footer />
        </div>
      );
    }
  } else {
    return(<div className='app bg-gray-900 pt-20 h-screen flex items-start flex-col text-white items-center'>
      <content className="mb-auto bg-gray-900 pr-20 pl-20 pb-20 h-screen flex items-start flex-col text-white items-center">
        <img src={logo} alt="Logo" className="h-50 sm:h-60"/>

        <div className="bg-gray-700 shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col">
          <h1 className='text-2xl mt-4 mb-4'>Admission Number</h1>
          <p className='mb-4'>Enter your admission number in the <code >XXXX/XXXX</code> format.<br/><em>eg:- 4512/2345</em></p>

          <input className='text-black flex flex-col py-2 px-4 rounded-lg' type="text" name="userText" id="userText" placeholder="Enter your admission no." value={userText} onChange={event => handleUserTextChange(event.target.value)}/>
          
          <input className='p-4 rounded-lg font-bold text-white mt-5 bg-green-600 hover:bg-gray-600 disabled:bg-gray-600' type="button" value="Start" onClick={handleStart} disabled={btnDisabled}/>
        </div>
      </content>
      <Footer />
    </div>)
  }
}